import styled, { useTheme } from 'styled-components';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { Heading3Text, ParagraphLargeText } from '../../../components/Texts';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../../common/responsive';
import Button from '../../../components/Button';
import CopyButton from '../../../components/CopyButton';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    margin-top: auto;
  }
`;

const CodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.background.secondary};
  border-radius: 12px;
  margin: 20px 0;
`;

const CodeText = styled(ParagraphLargeText)`
  font-family: 'Courier New', monospace;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 2px;
  color: ${({ theme }) => theme.text.title};
  @media ${PHONE_MEDIA_QUERY} {
    font-size: 20px;
  }
`;

const DiscountCode = ({ onClose, discountCode }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const theme = useTheme();

  const handleGoToShops = () => {
    onClose();
  };

  return (
    <Modal onClose={onClose}>
      <div>
        <div
          style={{
            display: 'flex',
            gap: 6,
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <Heading3Text
            style={{
              marginTop: '25px',
              fontWeight: '600',
              textAlign: 'center',
              color: theme.text.title,
            }}
          >
            You received a discount code!
          </Heading3Text>
          <ParagraphLargeText
            style={{
              color: theme.text.regular,
              textAlign: 'center',
              fontWeight: '400',
              marginTop: '8px',
            }}
          >
            Use this code to get discounts when shopping in our stores.
          </ParagraphLargeText>
        </div>

        <CodeContainer>
          <ParagraphLargeText
            style={{
              color: theme.text.secondary,
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            Your discount code
          </ParagraphLargeText>
          <CodeText>{discountCode}</CodeText>
        </CodeContainer>

        <ButtonContainer>
          <CopyButton
            textToCopy={discountCode}
            variant='secondary'
            fullWidth={isMobile}
            showTextChange={true}
            defaultText='Copy Code'
            copiedText='Copied!'
          />
          <Button fullWidth={isMobile} onClick={handleGoToShops}>
            Go to Shops
          </Button>
        </ButtonContainer>
      </div>
    </Modal>
  );
};

export default DiscountCode;
